import IActivityLogEntry from "../interface/iActivityLogEntry";
import IActivityLogFilter, {
  ALL_AREAS,
  RoleFilterKey,
} from "../interface/iActivityLogFilter";

const roleKeyOf = (entry: IActivityLogEntry): RoleFilterKey =>
  entry.actorRole ?? "unknown";

const searchableTexts = (entry: IActivityLogEntry): string[] => {
  const loggedEmail = entry.details.email;

  return [
    entry.actor?.name,
    entry.actor?.email,
    entry.subject?.name,
    entry.subject?.email,
    entry.message,
    entry.appointment?.coach,
    typeof loggedEmail === "string" ? loggedEmail : undefined,
  ].filter((text): text is string => typeof text === "string");
};

const filterActivityLog = (
  entries: IActivityLogEntry[],
  filter: IActivityLogFilter
): IActivityLogEntry[] => {
  const term = filter.search.trim().toLowerCase();

  return entries.filter(
    (entry) =>
      filter.roles[roleKeyOf(entry)] &&
      (filter.area === ALL_AREAS || entry.area === filter.area) &&
      (filter.status === "all" || entry.status === filter.status) &&
      (term === "" ||
        searchableTexts(entry).some((text) =>
          text.toLowerCase().includes(term)
        ))
  );
};

export default filterActivityLog;
